// extracted by mini-css-extract-plugin
export default {"container":"usage-value_container__boJYn","title":"usage-value_title__mYxsw","value":"usage-value_value__L8ERY","units":"usage-value_units__JMmYT"};